import axios from 'axios'
// import myAxios from './http'
import _,{get} from 'lodash'
import { message } from 'antd'
import { getCookieNew } from '@/public/utils'
import { getCookie } from '../public/utils'
const config = {token:getCookieNew('scs_token') ? getCookieNew('scs_token'): '075DFE1EE73515BEC6180B8200F36265'}
// 基本post请求
export function ajaxApi ({url, params, ContentType = 'application/json;charset=UTF-8', errcallback = () => {}}) {
  return axios({
    method: 'post',
    url: url,
    data: params,
    headers: {
      'Content-Type': ContentType,
      token: getCookieNew('scs_token') ? getCookieNew('scs_token'): ''
    },
    withCredentials: false
  }).then((res) => {
    return res
  })
    .catch(function (res) {
      if (res.response) {
        if (res.response.status !== 200) {
          if (res.response.status === 401 || res.response.data === '认证失败') {
            message.error('登录信息失效，请重新登录')
            window.location.href = '/login'
          } else {
            message.error(res.response.data.message || res.response.data.error_msg || res.response.data.Message)
            // return res
          }
          errcallback(res)
        }
      } else {
        errcallback(res)
        if (res.message) {
          message.error(res.message)
        }
      }
      throw res
    })
}

// 基本post请求（新版服务，如 erp-srm-sqm-service）
// 返回结构为 { code, message, data }，成功时 code 为 '0'（兼容 200）
// 业务失败：message.error 提示，同时把响应返回给调用方，由调用方根据 code 自行处理
export function ajaxApiNew ({url, params, ContentType = 'application/json;charset=UTF-8', errcallback = () => {}}) {
  return axios({
    method: 'post',
    url: url,
    data: params,
    headers: {
      'Content-Type': ContentType,
      token: getCookieNew('scs_token') ? getCookieNew('scs_token'): ''
    },
    withCredentials: false
  }).then((res) => {
    const code = res && res.data ? res.data.code : undefined
    if (code !== undefined && String(code) !== '0' && String(code) !== '200') {
      message.error(res.data.message || '请求失败')
      errcallback(res)
    }
    return res
  })
    .catch(function (res) {
      if (res.response) {
        if (res.response.status !== 200) {
          if (res.response.status === 401 || res.response.data === '认证失败') {
            message.error('登录信息失效，请重新登录')
            window.location.href = '/login'
          } else {
            message.error(res.response.data.message || res.response.data.error_msg || res.response.data.Message)
          }
          errcallback(res)
        }
      } else {
        errcallback(res)
        if (res.message) {
          message.error(res.message)
        }
      }
      throw res
    })
}

// post by wxf
export function axiosPost (url, postData) {
  return axios({
    method: 'post',
    url: url,
    data: postData,
    headers: {
      token: getCookieNew('scs_token') ? getCookieNew('scs_token') : '',
      accountId:getCookieNew('accountId') ? getCookieNew('accountId'): '',
    },
    withCredentials: false
  }).then((response) => {
    return response
  }).catch((res) => {
    if (res.response) {
      if (res.response.status !== 200) {
        if (res.response.status === 401 || res.response.data === '认证失败') {
          message.error('登录信息失效，请重新登录')
          window.location.href = '/login'
        } else {
          message.error(res.response.data.error_msg || res.response.data.Message)
        }
      }
    } else {
      if (res.message) {
        message.error(res.message)
      }
    }
    throw res
  })
}

// post请求  要传值
export function submitAxios ({url, params}) {
  return axios({
    method: 'post',
    url: url,
    data:params,
    withCredentials: false,
    headers:{...config}
  }).then((response) => {
    if(response.data.code&&response.data.code !=200&&response.data.version==100){
      message.error(response.data.message)
    }else{
      return response
    }
  }).catch((res) => {
    if (res.response) {
      if (res.response.status !== 200) {
        if (res.response.status === 401 || res.response.data === '认证失败') {
          message.error('登录信息失效，请重新登录')
          window.location.href = '/login'
        } else {
          message.error(res.response.data.error_msg  || res.response.data.Message||res.response.data.message)
        }
      }
    } else {
      if (res.message) {
        message.error(res.message)
      }
    }
    throw res
  })
}

export function ajaxApiGet ({url, params, ContentType = 'application/json;charset=UTF-8', errcallback = () => {}}) {
  return axios({
    method: 'get',
    url: url,
    data: params,
    headers: {
      'Content-Type': ContentType,
      token: getCookieNew('scs_token') ? getCookieNew('scs_token') : ''
    },
    withCredentials: false
  })
    .catch(function (res) {
      if (res.response) {
        if (res.response.status !== 200) {
          if (res.response.status === 401 || res.response.data === '认证失败') {
            message.error('登录信息失效，请重新登录')
            window.location.href = '/login'
          } else {
            message.error(res.response.data.message || res.response.data.error_msg || res.response.data.Message)
          }
          errcallback(res)
        }
      } else {
        errcallback(res)
        if (res.message) {
          message.error(res.message)
        }
      }
      throw res
    })
}
// get 请求
export function getMethod (url) {
  return axios({
    method: 'get',
    url: url,
    headers: {
      accountId:getCookieNew('accountId') ? getCookieNew('accountId'): '',
      Authorization: getCookieNew('scs_token') ? getCookieNew('scs_token'): '075DFE1EE73515BEC6180B8200F36265',
      ...config
    },
    withCredentials: false
  }).then((response) => {
    return response
  }).catch((res) => {
    if (res.response) {
      if (res.response.status !== 200) {
        if (res.response.status === 401 || res.response.data === '认证失败') {
          message.error('登录信息失效，请重新登录')
          window.location.href = '/login'
        } else {
          message.error(res.response.data.error_msg || res.response.data.Message)
        }
      }
    } else {
      if (res.message) {
        message.error(res.message)
      }
    }
    throw res
  })
}

// post请求  不要传值
export function downloadApi (url, param, filename) {
  // const form = this.getSearchForm() // 要发送到后台的数据
  return axios({ // 用axios发送post请求
    method: 'post',
    url: url, // 请求地址
    data: param, // 参数
    responseType: 'blob', // 表明返回服务器返回的数据类型,
    headers: {
      Authorization: getCookieNew('scs_token')? getCookieNew('scs_token') : '',
      ...config
    }
  }).then((res) => { // 处理返回的文件流
    const content = res.data
    const blob = new Blob([content])

    const fileName = filename
    if ('download' in document.createElement('a')) { // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else { // IE10+下载
      navigator.msSaveBlob(blob, fileName)
    }
  })
}

// 导出
export function fileDownloadApi ({url, param, filename}) {
  // const form = this.getSearchForm() // 要发送到后台的数据
  return axios({ // 用axios发送post请求
    method: 'post',
    url: url, // 请求地址
    data: param, // 参数
    responseType: 'blob', // 表明返回服务器返回的数据类型,
    transformRequest: [function (data) {
      // Do whatever you want to transform the data
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: getCookieNew('scs_token')? getCookieNew('scs_token'): '',
      ...config
    }
  }).then((res) => { // 处理返回的文件流
    const content = res.data
    const blob = new Blob([content])
    const fileName = filename
    if ('download' in document.createElement('a')) { // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else { // IE10+下载
      navigator.msSaveBlob(blob, fileName)
    }
  })
}

// 导出
export function fileDownloadApiNew ({url, param, filename}) {
  // const form = this.getSearchForm() // 要发送到后台的数据
  return axios({ // 用axios发送post请求
    method: 'post',
    url: url, // 请求地址
    data: param, // 参数
    responseType: 'blob', // 表明返回服务器返回的数据类型,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: getCookieNew('scs_token')? getCookieNew('scs_token') : '075DFE1EE73515BEC6180B8200F36265',
      ...config
    }
  }).then((res) => {
    const content = res.data
    const blob = new Blob([content])
    const fileName = filename
    if ('download' in document.createElement('a')) { // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else { // IE10+下载
      navigator.msSaveBlob(blob, fileName)
    }
    return res;
  }).catch((err)=>{
    return err;
  })
}

// 导出
export function fileDownloadApiToken ({url, param, filename}) {
  // const form = this.getSearchForm() // 要发送到后台的数据
  return axios({ // 用axios发送post请求
    method: 'post',
    url: url, // 请求地址
    data: param, // 参数
    responseType: 'blob', // 表明返回服务器返回的数据类型,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      token: getCookieNew('scs_token') ? getCookieNew('scs_token') : ''
    }
  }).then((res) => {
    const content = res.data
    const blob = new Blob([content])
    const fileName = filename
    if ('download' in document.createElement('a')) { // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else { // IE10+下载
      navigator.msSaveBlob(blob, fileName)
    }
  })
}

// 导出参数格式为json
export function fileDownloadApiHui ({url, param, filename},msg) {
  // const form = this.getSearchForm() // 要发送到后台的数据
  return axios({ // 用axios发送post请求
    method: 'post',
    url: url, // 请求地址
    data: param, // 参数
    responseType: 'blob', // 表明返回服务器返回的数据类型,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      token: getCookieNew('scs_token') ? getCookieNew('scs_token'): '',
      Authorization: getCookieNew('scs_token')? getCookieNew('scs_token') : ''
    }
  }).then((res) => {
    const content = res.data
    const blob = new Blob([content])
    const fileName = filename
    if ('download' in document.createElement('a')) { // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else { // IE10+下载
      navigator.msSaveBlob(blob, fileName)
    }
  }).catch(res=>{
    if(msg) { 
      message.error(msg)
    }
  })
}

// .net请求列表分页查询
export function netApi ({url, pageIndex = 0, pageSize = 15, action = 'getpurchasereturnforsupplierlist', appkey = 'sigo', appsecret = 'sigo',
  params, ContentType = 'application/x-www-form-urlencoded;charset=UTF-8', config = () => {}}) {
  let headers = {
    'Content-Type': ContentType,
    'token': getCookie('scs_token')||'',
    accountId:getCookieNew('accountId') ? getCookieNew('accountId'): '',
  }
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'post',
      data: {
        appkey: appkey,
        appsecret: appsecret,
        accesstoken: getCookie('scs_token')||'',
        action: action,
        pageIndex: pageIndex,
        pageSize: pageSize,
        data: params
      },
      headers
    }).then(resolve)
      .catch(error => {
        if (error.response) {
          if (error.response.status !== 200) {
            if (error.response.status === 401 || error.response.data === '认证失败') {
              message.error('登录信息失效，请重新登录')
              window.location.href = '/login'
            } else {
              message.error(error.response.data.message || error.response.data.error_msg || error.response.data.Message)
              return error
            }
            config(error)
          }
        } else {
          config(error)
          if (error.message) {
            message.error(error.message)
          }
        }
        reject(error)
      })
  })
};

// .net请求列表纯查询
export function netApiOriginPlace ({url, action = 'getdictionlist', appkey = 'sigo', appsecret = 'sigo',
  params, ContentType = 'application/x-www-form-urlencoded;charset=UTF-8', config = () => {}}) {
  let headers = {
    'Content-Type': ContentType,
    ...config
  }
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'post',
      data: {
        appkey: appkey,
        appsecret: appsecret,
        accesstoken: '075DFE1EE73515BEC6180B8200F36265',
        action: action,
        data: params
      },
      headers
    }).then(resolve)
      .catch(error => {
        if (error.response) {
          if (error.response.status !== 200) {
            if (error.response.status === 401 || error.response.data === '认证失败') {
              message.error('登录信息失效，请重新登录')
              window.location.href = '/login'
            } else {
              message.error(error.response.data.message || error.response.data.error_msg || error.response.data.Message)
              return error
            }
            config(error)
          }
        } else {
          config(error)
          if (error.message) {
            message.error(error.message)
          }
        }
        reject(error)
      })
  })
};

// .net请求列表纯查询
export function netApiNo ({url, action = 'getdictionary', appkey = 'sigo', appsecret = 'sigo',
  params, ContentType = 'application/x-www-form-urlencoded;charset=UTF-8', config = () => {}}) {
  let headers = {
    'Content-Type': ContentType,
    'token': getCookie('scs_token')||'',
   accountId:getCookieNew('accountId') ? getCookieNew('accountId') : '',
  }
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'post',
      data: {
        appkey: appkey,
        appsecret: appsecret,
        accesstoken: getCookie('scs_token')||'',
        action: action,
        data: params
      },
      headers
    }).then(resolve)
      .catch(error => {
        // debugger
        if (error.response) {
          if (error.response.status !== 200) {
            if (error.response.status === 401 || error.response.data === '认证失败') {
              message.error('登录信息失效，请重新登录')
              window.location.href = '/login'
            } else {
              message.error(error.response.data.message || error.response.data.error_msg || error.response.data.Message)
              return error
            }
            config(error)
          }
        } else {
          config(error)
          if (error.message) {
            message.error(error.message)
          }
        }
        reject(error)
      })
  })
};
// .net上传
export function netApiUpload ({url, action = 'getdictionary', appkey = 'sigo', appsecret = 'sigo',
  params, file = '', ContentType = 'multipart/form-data; boundary=----WebKitFormBoundaryQDidycNdvQH6aBNC', config = () => {}}) {
  let headers = {
    'Content-Type': ContentType,
    'token': getCookie('scs_token')||'',
    accountId:getCookieNew('accountId') ? getCookieNew('accountId'): '',
  }
  let _data = {
    appkey: appkey,
    appsecret: appsecret,
    accesstoken: getCookie('scs_token')||'',
    action: action,
    data: params
  }
  const _obj = new FormData()
  _obj.append('requestEntity', JSON.stringify(_data)),
  _obj.append('file', file)
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'post',
      data: _obj,
      headers
    }).then(resolve)
      .catch(error => {
        if (error.response) {
          if (error.response.status !== 200) {
            if (error.response.status === 401 || error.response.data === '认证失败') {
              message.error('登录信息失效，请重新登录')
              window.location.href = '/login'
            } else {
              message.error(error.response.data.message || error.response.data.error_msg || error.response.data.Message)
              return error
            }
            config(error)
          }
        } else {
          config(error)
          if (error.message) {
            message.error(error.message)
          }
        }
        reject(error)
      })
  })
};
// net导出
export function netExport ({url, action = 'getdictionary', filename, appkey = 'sigo', appsecret = 'sigo',
  params, ContentType = 'application/x-www-form-urlencoded;charset=UTF-8'}) {
  return axios({
    method: 'post',
    url: url,
    data: {
      appkey: appkey,
      appsecret: appsecret,
      accesstoken: getCookieNew('scs_token'),
      action: action,
      data: params
    },
    responseType: 'blob',
    headers: {
      'Content-Type': ContentType,
      'token': getCookieNew('scs_token'),
      accountId:getCookieNew('accountId') ? getCookieNew('accountId'): '',
    },
    withCredentials: false
  }).then((res) => {
    const content = res.data
    const blob = new Blob([content])
    const fileName = filename
    if ('download' in document.createElement('a')) { // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else { // IE10+下载
      navigator.msSaveBlob(blob, fileName)
    }
  })
}

// 基本post请求
export function newAjaxApi({ url, params, ContentType = 'application/json;charset=UTF-8', errcallback = () => { } }) {
  return axios({
    method: 'post',
    url: url,
    data: params,
    headers: {
      'Content-Type': ContentType,
      token: getCookieNew('scs_token') ?getCookieNew('scs_token'): '',
      accountId:getCookieNew('accountId') ? getCookieNew('accountId') : '',
    },
    withCredentials: false
  }).then((res) => {
    let _keys;
    if (res.data instanceof Object) {
      _keys = Object.keys(res.data);
    };
    if (_.get(res, 'data.code') && _.get(res, 'data.code') != 200 && _.get(res, 'data.code') != 'success' && _keys instanceof Array && _keys.includes('data') && _keys.includes('message')) {
      let errorText = _.get(res, 'data.msg') || _.get(res, 'data.message') || _.get(res, 'data.error_msg') || _.get(res, 'data.Message')
      message.error(errorText)
      return Promise.reject(res)
    }
    return res
  })
    .catch(function (res) {
      if (res.response) {
        if (res.response.status !== 200) {
          if (res.response.status === 401 || res.response.data === '认证失败') {
            message.error('登录信息失效，请重新登录')
            window.location.href = '/login'
          } else {
            message.error(res.response.data.message || res.response.data.error_msg || res.response.data.Message)
            // return res
          }
          errcallback(res)
        }
      } else {
        errcallback(res)
        if (res.message) {
          message.error(res.message)
        }
      }
      throw res
    })
}

export let submitMethod
export let format
export let postMethod
export let postMethodDepartment



// WEBPACK FOOTER //
// ./src/server/index.js